module.exports = __webpack_public_path__ + "static/party-06e66ca7022e14fa82f7ec65177f6dbf.mp3";